import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import "../style/Contact.css";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Contact = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    emailjs
      .send(
        "service_dui89vd",
        "template_api2lht",
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message,
        },
        "gj6mNHRnQwK9oX652"
      )
      .then(() => {
        setStatus(t("contact.success"));
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      })
      .catch(() => {
        setStatus(t("contact.error"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <main className="contact-page">
      <Header />

      <section className="contact-hero">
        <div className="contact-hero-content">
          <span className="contact-eyebrow">{t("contact.heroEyebrow")}</span>
          <h1>{t("contact.heroTitle")}</h1>
          <p>{t("contact.heroText")}</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="contact-info">
          <span className="contact-eyebrow dark">
            {t("contact.getInTouch")}
          </span>

          <h2>{t("contact.infoTitle")}</h2>
          <p>{t("contact.infoText")}</p>

          <div className="info-box">
            <h3>{t("contact.location")}</h3>
            <p>{t("contact.locationValue")}</p>
          </div>

          <div className="info-box">
            <h3>{t("contact.email")}</h3>
            <p>autopark.lennestadt@gmail.com</p>
          </div>

          <div className="info-box">
            <h3>{t("contact.phone")}</h3>
            <p>+49 175 1932947</p>
          </div>

          <div className="info-box">
            <h3>{t("contact.workingHours")}</h3>
            <p>{t("contact.workingHoursValue")}</p>
          </div>
        </div>

        <form className="contact-form" onSubmit={sendEmail}>
          <div className="form-row">
            <input
              type="text"
              name="name"
              placeholder={t("contact.fullName")}
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder={t("contact.emailAddress")}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <input
              type="text"
              name="phone"
              placeholder={t("contact.phoneNumber")}
              value={formData.phone}
              onChange={handleChange}
            />

            <input
              type="text"
              name="subject"
              placeholder={t("contact.subject")}
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>

          <textarea
            name="message"
            placeholder={t("contact.message")}
            rows="7"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" disabled={loading}>
            {loading ? t("contact.sending") : t("contact.sendMessage")}
          </button>

          {status && <p className="form-status">{status}</p>}
        </form>
      </section>

      <section className="map-section">
        <div className="map-header">
          <span className="contact-eyebrow dark">{t("contact.findUs")}</span>
          <h2>{t("contact.ourLocation")}</h2>
        </div>

        <div className="map-box">
         <iframe
  title={t("contact.mapTitle")}
  src="https://www.google.com/maps?q=Zur%20Christinenh%C3%BCtte%203,%2057368%20Lennestadt,%20Germany&output=embed"
  loading="lazy"
  allowFullScreen
></iframe>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Contact;